import { combineReducers } from 'redux';
import folders, { MessageFolderState } from './folders';
import messageDetailReducer, { MessageDetailState } from './detail';
import messageComposeReducer, { MessageComposeState } from './compose';
import messageFindProviderReducer, { MessageFindProviderState } from './findProvider';
import messageDownloadReducer, { MessageDownloadState } from './downloads';

export interface MessagingState {
  inbox: MessageFolderState;
  outbox: MessageFolderState;
  detail: MessageDetailState;
  compose: MessageComposeState;
  findProvider: MessageFindProviderState;
  downloads: MessageDownloadState;
}

export * from './detail';
export * from './folders';

export default combineReducers({
  inbox: folders.inbox,
  outbox: folders.outbox,
  detail: messageDetailReducer,
  compose: messageComposeReducer,
  findProvider: messageFindProviderReducer,
  downloads: messageDownloadReducer
});
